import customerMemberCard from '@/api/customer/customer-member-card'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  formViewData: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,

  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formViewData = data
    } else {
      split(index, ',').forEach(el => {
        state.formViewData[el] = data[el]
      })
    }
  }
}

export const actions = {
         fetch(context, attrubutes = {}) {
           let params = Object.assign(
             {
               page: context.state.pagination.page,
               perPage: context.state.pagination.perPage,
               branch_id: context.state.branch_id,
               filter: {
                 search: context.state.search
               }
             },
             attrubutes
           )
           return customerMemberCard.get({ params }).then(response => {
             context.commit('RECEIVE_RESOURCES', response)
             return Promise.resolve(response)
           })
         },

         async find(context, id) {
           if (_.isEmpty(context.state.edit_data)) {
             let response = await customerMemberCard.find(id)
             context.commit('SET_EDIT_DATA', response.data)
           }
         },
         destroy(context, id) {
           return customerMemberCard.destroy(id)
         },
         update(context, { id, data }) {
           return customerMemberCard.update(id, data)
         },
         store(context, data) {
           return customerMemberCard.store(data)
         },
         checkExist(context, data) {
           return customerMemberCard.checkExist(data)
         },
         async getFormViewData(context, { params, index }) {
           let response = await customerMemberCard.formModel({ params: params })
           context.commit('SET_VIEW_MODELS', {
             data: response.data,
             index: index
           })
           return Promise.resolve(response)
         }
       }
